import stripCategoryId from './stripCategoryId';
export const formatFilter = {
    list: (search) => {
        return search.list
            ? Object.keys(search.list).map(filter => {
                return {
                    id: stripCategoryId(filter),
                    values: search.list[filter]
                };
            })
            : [];
    },
    multiList: (search) => {
        return search.multiList
            ? Object.keys(search.multiList).map(filter => {
                return {
                    id: stripCategoryId(filter),
                    values: search.multiList[filter]
                };
            })
            : [];
    },
    boolean: (search) => {
        return search.boolean
            ? Object.keys(search.boolean).map(filter => {
                return {
                    id: stripCategoryId(filter),
                    value: JSON.parse(search.boolean[filter])
                };
            })
            : [];
    },
    range: (search) => {
        return search.range
            ? Object.keys(search.range).map(filter => {
                const [min, max] = search.range[filter];
                return {
                    id: stripCategoryId(filter),
                    min: parseInt(min, 10),
                    max: parseInt(max, 10)
                };
            })
            : [];
    }
};
export const formatFromState = {
    list: (state) => {
        if (state.length === 0)
            return { list: null };
        return {
            list: state.reduce((acc, curr) => {
                return Object.assign({}, acc, { [curr.id]: curr.values });
            }, {})
        };
    },
    range: (state) => {
        if (state.length === 0)
            return { range: null };
        return {
            range: state.reduce((acc, curr) => {
                return Object.assign({}, acc, { [curr.id]: [curr.min, curr.max] });
            }, {})
        };
    },
    boolean: (state) => {
        if (state.length === 0)
            return { boolean: null };
        return {
            boolean: state.reduce((acc, curr) => {
                return Object.assign({}, acc, { [curr.id]: curr.value });
            }, {})
        };
    },
    multiList: (state) => {
        if (state.length === 0)
            return { multiList: null };
        return {
            multiList: state.reduce((acc, curr) => {
                return Object.assign({}, acc, { [curr.id]: curr.values });
            }, {})
        };
    }
};
//# sourceMappingURL=formatFilter.js.map